/**
 * Reference-counted scroll lock manager for overlays.
 * Prevents conflicts when multiple overlays (modals, drawers) are stacked.
 * Only unlocks scroll when all overlays are closed.
 */

let count = 0;

export function acquireScrollLock() {
  count++;
  if (count === 1) {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }
}

export function releaseScrollLock() {
  if (count > 0) {
    count--;
    if (count === 0) {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }
  } else {
    console.warn(`[ScrollLock] ⚠️ attempted release when count is already 0!`);
  }
}
